import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CategoryCard } from '../../core/models/interfaces-general';
import { UiEmptyImageComponent } from './ui-empty-image.component';

@Component({
    selector: 'app-category-card',
    standalone: true,
    imports: [CommonModule, RouterLink, UiEmptyImageComponent],
    template: `
    <a 
      [routerLink]="item.targetUrl || null"
      class="group relative block w-full aspect-[3/4] sm:aspect-[4/5] rounded-[2rem] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 select-none"
    >
      <!-- IMAGEN DE FONDO (Con efecto zoom suave al hacer hover) -->
      <img 
        *ngIf="item.imageUrl"
        [src]="item.imageUrl" 
        [alt]="item.title"
        class="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700 ease-out"
      />
      <app-ui-empty-image *ngIf="!item.imageUrl" iconClass="w-12 h-12"></app-ui-empty-image>

      <!-- OVERLAY DEGRADADO (Desde var(--bg-secondary) opaco en la base a transparente arriba) -->
      <div 
        class="absolute inset-0 pointer-events-none transition-opacity duration-300"
        style="background: linear-gradient(to top, var(--bg-secondary) 0%, rgba(0,0,0,0.3) 30%, transparent 60%);"
      ></div>

      <!-- TEXTO UBICADO EN LA PARTE INFERIOR -->
      <div class="absolute bottom-6 left-6 right-6 z-10">
        <h3 class="text-white font-extrabold text-lg sm:text-xl tracking-wider uppercase font-sans drop-shadow-md">
          {{ item.title }}
        </h3>
      </div>
    </a>
  `
})
export class CategoryCardComponent {
    @Input({ required: true }) item!: CategoryCard;
}